import { Viewport, type ViewportLiteral } from "../pixel-accessor";
import { isBestFitReversePixelMapper } from "../pixel-mapper";
import type { OutputViewportStrategy } from "./OutputViewportStrategy";
import type { ImageAdapter } from "../image-adapter";
import type { ReversePixelMapper } from "../pixel-mapper";

/**
 * Best fit viewport resolution strategy.
 * Matches if reverse pixel mapper supports best-fit viewport calculation and when 'viewport' option is set to
 * "bestFit" or true, or if pixel mapper forces best-fit viewport.
 */
export class BestFitViewport implements OutputViewportStrategy {
  /**
   * @inheritDoc
   */
  readonly priority = 2;

  /**
   * @inheritDoc
   */
  match(
    reversePixelMapper: ReversePixelMapper,
    viewport: "bestFit" | boolean | ViewportLiteral
  ): boolean {
    return (
      isBestFitReversePixelMapper(reversePixelMapper) &&
      (reversePixelMapper.forceBestFit ||
        viewport === "bestFit" ||
        viewport === true)
    );
  }

  /**
   * @inheritDoc
   */
  getOutputViewport(
    image: ImageAdapter<unknown>,
    reversePixelMapper: ReversePixelMapper
  ): Viewport {
    if (isBestFitReversePixelMapper(reversePixelMapper)) {
      return reversePixelMapper.getBestFitViewport(image.getViewport());
    }
    throw new TypeError(
      "Given ReversePixelMapper don't support best-fit output viewport"
    );
  }
}
